import { endOfDay } from 'date-fns/endOfDay';
import { getUnixTime } from 'date-fns/getUnixTime';
import { Identifier } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';

import { normalizeEvent } from './normalizers'; // Assume you have this normalizer

import type { Event } from './_types'; // Assume you have defined Event type

interface FetchEventsOptions {
  userId?: Identifier;
  page?: number;
  perPage?: number;
  search?: string;
  startDate?: string;
  endDate?: string;
}

interface FetchEventsResponse {
  events: Event[];
  total: number;
}

export const fetchEvents = async ({
  userId,
  page = 1,
  perPage = 20,
  search,
  startDate,
  endDate,
}: FetchEventsOptions): Promise<FetchEventsResponse> => {
  const params: Record<string, any> = {
    page,
    per: perPage,
  };

  if (userId !== undefined) {
    params.user_id = userId;
  }

  if (search) {
    params.search = search;
  }

  if (startDate) {
    params.start_date = getUnixTime(new Date(startDate));
  }

  if (endDate) {
    params.end_date = getUnixTime(endOfDay(new Date(endDate)));
  }

  const response = await api.get('/api/v4/events', {
    params,
  });

  const events = response.data.event?.map((e) => normalizeEvent(e)) || [];
  const total = response.data.meta?.total || 0;

  return { events, total };
};
